(function () {
  const selector = '.single-line-carousel';

  function initSingleLineCarousel(sliderEl) {
    if (!sliderEl || sliderEl.dataset.initialized === 'true') return;

    const loop = sliderEl.dataset.loop === 'true';
    const autoplayEnabled = sliderEl.dataset.autoplay === 'true';
    const autoplayDelay = Number(sliderEl.dataset.autoplaySpeed || 4000);
    const spaceBetween = Number(sliderEl.dataset.spaceBetween || 12);
    const showPagination = sliderEl.dataset.showPagination === 'true';
    const enableAnchorScroll = sliderEl.dataset.enableAnchorScroll !== 'false';
    const anchorOffset = Number(sliderEl.dataset.anchorOffset || 0);

    const swiperEl = sliderEl.querySelector('.swiper');
    const nextEl = sliderEl.querySelector('.single-line-carousel__btn--next');
    const prevEl = sliderEl.querySelector('.single-line-carousel__btn--prev');
    const paginationEl = sliderEl.querySelector('.single-line-carousel__pagination');
    const slideCount = sliderEl.querySelectorAll('.swiper-wrapper > .swiper-slide').length;

    if (!swiperEl || slideCount === 0) return;

    const enableLoop = loop && slideCount > 1;

    // eslint-disable-next-line no-undef
    const swiper = new Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween,
      speed: 550,
      loop: enableLoop,
      loopAdditionalSlides: Math.min(4, slideCount),
      watchOverflow: true,
      allowTouchMove: true,
      grabCursor: true,
      autoplay: autoplayEnabled
        ? {
            delay: autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }
        : false,
      navigation: nextEl && prevEl
        ? {
            nextEl,
            prevEl,
          }
        : undefined,
      pagination: showPagination && paginationEl && slideCount > 1
        ? {
            el: paginationEl,
            clickable: true,
          }
        : undefined,
    });

    sliderEl.dataset.initialized = 'true';

    const updateNav = () => {
      if (!nextEl || !prevEl || enableLoop) return;
      const isFirst = swiper.realIndex === 0;
      const isLast = swiper.realIndex === slideCount - 1;
      nextEl.style.display = isLast ? 'none' : '';
      prevEl.style.display = isFirst ? 'none' : '';
    };

    updateNav();
    swiper.on('slideChange', updateNav);

    if (enableAnchorScroll) {
      const findAnchorTarget = (targetId) => {
        const directTarget = document.getElementById(targetId);
        if (directTarget) return directTarget;

        const sectionSuffix = targetId.includes('__') ? targetId.slice(targetId.lastIndexOf('__')) : '';
        if (!sectionSuffix) return null;

        return Array.from(document.querySelectorAll('[id]')).find((element) => {
          return element.id.endsWith(sectionSuffix) && !element.id.startsWith('shopify-section-');
        }) || null;
      };

      sliderEl.addEventListener('click', (event) => {
        const link = event.target.closest('a.single-line-carousel__card[href]');
        if (!link) return;
        const href = link.getAttribute('href');

        if (!href || href === '#') return;

        let url;
        try {
          url = new URL(href, window.location.href);
        } catch (_error) {
          return;
        }

        if (!url.hash) return;
        if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;

        const targetId = decodeURIComponent(url.hash.slice(1));
        if (!targetId) return;
        const targetEl = findAnchorTarget(targetId);
        if (!targetEl) return;

        event.preventDefault();
        const scrollTop = targetEl.getBoundingClientRect().top + window.scrollY - (Number.isFinite(anchorOffset) ? anchorOffset : 0);
        window.scrollTo({ top: Math.max(scrollTop, 0), behavior: 'smooth' });
        window.history.replaceState({}, '', url.hash);
      });
    }

    document.addEventListener('shopify:block:select', (event) => {
      const blockId = event?.detail?.blockId;
      if (!blockId || !swiper) return;
      const slideEl = sliderEl.querySelector(`[data-block-id="${blockId}"]`);
      if (!slideEl) return;
      const index = Array.from(slideEl.parentNode.children).indexOf(slideEl);
      swiper.slideToLoop(index);
    });
  }

  function init() {
    document.querySelectorAll(selector).forEach(initSingleLineCarousel);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
